import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(auth)/register/player/page.tsx");
